import { usePutMutation } from "@/api/swr/useMutation";
import { evaluationReportCreateSchema } from "@/schema/console/evaluation-reports/EvaluationReportCreate";
import { z } from "zod";

type Config = Parameters<
  typeof usePutMutation<typeof evaluationReportCreateSchema, z.ZodNull>
>[3];

export const useSaveEvaluationReport = (id: string, config?: Config) => {
  return usePutMutation(
    evaluationReportCreateSchema,
    z.null(),
    `/console/evaluation_reports/${id}/save_changes`,
    config,
  );
};
